'use strict';

import React, { Component } from 'react'

import stripTags from 'striptags'

import Image from '@Pure/Image'
import Link  from '@Pure/Link'

import { isTrue } from '@root/utility'

const { app, moment } = window;

export default class ArtistRow extends Component
{
	render ()
	{
		const { data, blank=true, fields, ...props } = this.props;

		moment.locale('fr');

		const blank_props = blank === true
		? { target: '_blank', rel: 'noopener noreferrer' }
		: { };

		const link =
		(
			<Link className="u-link-only" { ...blank_props }
				href={ '/configuration/artistes/' + data.id }>
				<span className="u-readers-only">
					Page de l'artiste
				</span>
			</Link>
		);

		let output =
		(
			<div className="c-dashboard__row">

				<div className="c-dashboard__cell Artist-images_url">

					{
						data.images?.[0]?.url ?
						(
							<Image className="c-dashboard__cell-img"
								src={ data.images[0].url }
							/>
						)
						: undefined
					}

					{ link }

				</div>

				<div className="c-dashboard__cell Artist-name">

					<div className="c-dashboard__long-text">
						{ data.name }
					</div>

					{ link }

				</div>

				<div className="c-dashboard__cell Artist-description">

					<div className="c-dashboard__long-text">
						{
							app.getTruncatedText(
								stripTags(
									(data.description || '')
									.split('&nbsp;')
									.join(' ')
									.split('</p>')
									.join('</p> ')
								),
								160,
								true
							)
						}
					</div>

					{ link }

				</div>

				<div className="c-dashboard__cell Artist-linked_products">

					<div className="c-dashboard__long-text">
						{ data.__products_count || '-' }
					</div>

					{ link }

				</div>

				<div className="c-dashboard__cell Artist-disabled">

					{ isTrue(data.disabled) ? 'Oui' : undefined }

					{ link }

				</div>

			</div>
		);

		return output;
	}
}